import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class StandardOptionCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "オプション名・画像",
		description: "",
		isBasicSetup: true,
	});

	public salesTypeAndPrice = createFeatureIslandCategoryStore({
		title: "販売タイプ・料金",
		description: "",
		isBasicSetup: true,
	});

	public planRestrictionsAndConnection = createFeatureIslandCategoryStore({
		title: "プラン制限・紐付け",
		description: "",
		isBasicSetup: true,
	});

	public subOption = createFeatureIslandCategoryStore({
		title: "サブオプション",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	public discountSetting = createFeatureIslandCategoryStore({
		title: "ディスカウントの適用設定",
		description: "",
		isBasicSetup: false,
	});

	public stock = createFeatureIslandCategoryStore({
		title: "在庫",
		description: "",
		isBasicSetup: false,
	});

	public salesTerm = createFeatureIslandCategoryStore({
		title: "販売期間",
		description: "",
		isBasicSetup: false,
	});

	public cancelPolicy = createFeatureIslandCategoryStore({
		title: "キャンセルポリシー",
		description: "",
		isBasicSetup: false,
	});

	public optionAttributes = createFeatureIslandCategoryStore({
		title: "特殊なオプション属性",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [
		this.base,
		this.salesTypeAndPrice,
		this.planRestrictionsAndConnection,
		this.discountSetting,
		this.subOption,
		this.stock,
		this.salesTerm,
		this.cancelPolicy,
		this.optionAttributes,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const standardOptionCategoriesAndManagerStore = new StandardOptionCategoriesAndManagerStore();
